import { getCurrentUserID } from 'src/modules/authentication/storage/user/utils';
import SubjectAPIs from '../../db/subject';
import { mapPaginatedSubjects, mapSubjectToNode } from './utils';
export const epSubjectQueries = {
    async ep_subjectDetails(_, { subjectID }, context) {
        const result = await SubjectAPIs.getByID(getCurrentUserID(), subjectID);
        return mapSubjectToNode(result);
    },
    async ep_subjectList(_, { examLevelID, pagination, type }, context) {
        const result = await SubjectAPIs.getList(getCurrentUserID(), examLevelID, type, pagination);
        return mapPaginatedSubjects(result);
    },
};
